import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue";
const _hoisted_1 = {
  class: "aside-header"
};
const _hoisted_2 = {
  class: "btn-wrap"
};
const _hoisted_3 = {
  class: "btn-wrap"
};
const _hoisted_4 = {
  class: "btn-wrap"
};
const _hoisted_5 = {
  class: "btn-wrap"
};
const _hoisted_6 = {
  class: "history-wrap"
};
const _hoisted_7 = {
  class: "line-item"
};
const _hoisted_8 = {
  class: "line-item"
};
const _hoisted_9 = {
  class: "line-item"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_timeline_item = _resolveComponent("el-timeline-item");
  const _component_el_timeline = _resolveComponent("el-timeline");
  const _component_el_scrollbar = _resolveComponent("el-scrollbar");
  const _component_el_aside = _resolveComponent("el-aside");
  const _directive_has = _resolveDirective("has");
  return _openBlock(), _createBlock(_component_el_aside, {
    width: "300px"
  }, {
    default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_el_button, {
      class: "btn",
      type: "primary",
      onClick: _cache[0] || (_cache[0] = $event => $setup.showAdd('src'))
    }, {
      default: _withCtx(() => [...(_cache[4] || (_cache[4] = [_createTextVNode("互联网渠道物料", -1)]))]),
      _: 1
    })])), [[_directive_has, 'needs:add']]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [_createVNode(_component_el_button, {
      class: "btn",
      type: "primary",
      onClick: _cache[1] || (_cache[1] = $event => $setup.showAdd('sms'))
    }, {
      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("新建短信需求", -1)]))]),
      _: 1
    })])), [[_directive_has, 'needs:addSms']]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_4, [_createVNode(_component_el_button, {
      class: "btn",
      type: "primary",
      onClick: _cache[2] || (_cache[2] = $event => $setup.showAdd('finished'))
    }, {
      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [_createTextVNode("新建成品物料需求", -1)]))]),
      _: 1
    })])), [[_directive_has, 'needs:addFinished']]), _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_button, {
      class: "btn",
      type: "primary",
      onClick: _cache[3] || (_cache[3] = $event => $setup.showAdd('printed'))
    }, {
      default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("新建印刷品制作需求", -1)]))]),
      _: 1
    })])), [[_directive_has, 'printed:add']])]), _cache[8] || (_cache[8] = _createElementVNode("div", {
      class: "history-tit"
    }, "我的历史记录", -1)), _createElementVNode("div", _hoisted_6, [_createVNode(_component_el_scrollbar, {
      height: "100%"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_timeline, null, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activities, (activity, index) => {
          return _openBlock(), _createBlock(_component_el_timeline_item, {
            key: index,
            icon: activity.icon,
            type: "primary",
            color: activity.color,
            size: activity.size,
            timestamp: activity.optTime
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_7, _toDisplayString(activity.optContent), 1), _createElementVNode("div", _hoisted_8, _toDisplayString(activity.optTargetName), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(activity.optRemark), 1)]),
            _: 2
          }, 1032, ["icon", "color", "size", "timestamp"]);
        }), 128))]),
        _: 1
      })]),
      _: 1
    })])]),
    _: 1
  });
}